module.exports = __webpack_public_path__ + "static/media/30GalleryPuppets.d800d766.jpg";